import React from 'react';
import authContext, { AuthContext } from './context';

export type UseTokenAuthHook = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends Record<string, any>,
>() => AuthContext<T>;

export const useTokenAuth: UseTokenAuthHook = <
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends Record<string, any>,
>() => {
  const context = React.useContext<AuthContext<T>>(
    authContext as unknown as React.Context<AuthContext<T>>,
  );
  return context;
};
